/**
 *  Context: questions
 */
import React, { useReducer } from 'react';
import PropTypes from 'prop-types';

const questionReducer = (state, action) => {
  switch (action.type) {
    case "clear":
      return [state[0]];
    case "next":
      return [...state, action.item];
  }
  return state;
}

// Create a Context
const QuestionsContext = React.createContext();

const QuestionsProvider = ({ children, data }) => {

    const [list, dispatchQuestions] = useReducer(questionReducer,[data.stories[0]]);
    const type = data.type;

    const clearList = () => {
      dispatchQuestions({type: "clear"});
    }

    const nextAction = (item) => {
      dispatchQuestions({type: "next", item});
    }

  const value = {
    list, 
    type,
    clearList, 
    nextAction
  };

  return (
    <QuestionsContext.Provider value={value}>
      {children}
    </QuestionsContext.Provider>
  )
}
QuestionsProvider.propTypes = {
  children: PropTypes.element
}

export {QuestionsContext, QuestionsProvider};
